<template>
  <Layout>
    <LayoutBody mode="horizontal" class="page-body--row">
      <LayoutContent class="content-body">
        <Panel class="tools">
          <Toolbar
            justifyContent="center"
            v-if="isShowCountDown && computedIsShowResult && $route.query.paperStatus == 1"
          >
            <div class="result-num">
              {{ $t('hsk_practice_num1') }}
              <span class="result-correct">{{ correctNum }}</span>
              {{
                $t('hsk_practice_num2', {
                  totalNum: questionAnswerList.length,
                })
              }}
            </div>
          </Toolbar>
          <div class="subject_list">
            <div class="subject_list-item">
              <div class="subject_list-flex">
                <div class="subject_list-line"></div>
                <div class="title">
                  {{
                    $t(`hsk_${selectObj.segment_code}_part_title`, {
                      count: selectObj.part_code,
                    })
                  }}
                </div>
              </div>

              <div>
                <span
                  v-for="(ques, no) in selectObj.questionList"
                  :key="no"
                  @click="selectQues(ques, selectObj.topic_title, false)"
                  v-show="ques.index"
                  :class="[
                    currentQuesIndex && currentQuesIndex <= questionAllList.length
                      ? questionAllList[currentQuesIndex - 1].index === ques.index
                        ? 'active'
                        : ''
                      : '',
                    questionAnswerList[computedCurrentIndex(ques.index) - 1] &&
                    questionAnswerList[computedCurrentIndex(ques.index) - 1].answer
                      ? 'finished'
                      : '',
                    $route.query.paperStatus == 1
                      ? (questionAnswerList[computedCurrentIndex(ques.index) - 1] &&
                          questionAnswerList[computedCurrentIndex(ques.index) - 1].judge == 1) ||
                        Object.values(MARK_RESULT_TYPE).includes(ques.topic_type)
                        ? 'right'
                        : 'error'
                      : '',
                  ]"
                  >{{ ques.index }}</span
                >
              </div>
            </div>
          </div>
          <Toolbar
            justifyContent="center"
            v-if="isShowCountDown && $route.query.paperStatus != 1"
            class="toolbar-submit"
          >
            <button class="btn-yellow btn-submit" @click="submit">
              {{ $t('hsk_submit_paper') }}
            </button>
          </Toolbar>
          <div v-if="isShowCountDown && computedIsShowResult && $route.query.paperStatus == 1">
            <div class="hsk-tips">{{ $t('hsk_link_tips') }}</div>
            <Toolbar justifyContent="center" style="border-bottom: none">
              <button class="btn-yellow btn-submit" @click="jumpTest()">
                {{ $t('hsk_link_test') }}
              </button>
            </Toolbar>
          </div>
        </Panel>

        <div class="content">
          <Panel class="stem">
            <div class="stem--title">
              <div class="stem--title_text">
                <strong>{{ title }}</strong>
                <div class="proportion" v-show="selectObj.topic_title">
                  <span>{{
                    $t(`hsk_${selectObj.segment_code}_part_title`, {
                      count: selectObj.part_code,
                    })
                  }}</span>
                  <span>{{ computedCurrentNum ? computedCurrentNum : $t('hsk_example') }}</span>
                </div>
              </div>
            </div>
            <div class="stem--content">
              <slot name="content"></slot>
            </div>
          </Panel>
          <div class="page-tools">
            <ButtonTool
              class="control"
              type="prev"
              :disabled="disabledPrevButton"
              @click.native="onPrev"
            ></ButtonTool>
            <ButtonTool
              type="play"
              @click.native="playClickHandler"
              v-show="showButtonPlay"
            ></ButtonTool>
            <ButtonTool
              type="pause"
              @click.native="stopClickHandler"
              v-show="showButtonPause"
            ></ButtonTool>
            <ButtonTool
              class="control"
              type="next"
              :disabled="disabledNextButton"
              @click.native="onNext"
            ></ButtonTool>
          </div>
        </div>
      </LayoutContent>
    </LayoutBody>
    <!-- 弹框确认是否提交试卷 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="300px"
      :show-close="false"
      top="30vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span>{{ $t('hsk_submit_msg') }}</span>
      <div slot="footer" class="dialog-footer">
        <span @click="cancel">{{ $t('button_common_cancel') }}</span>
        <span @click="confirm">{{ $t('button_common_ok') }}</span>
      </div>
    </el-dialog>
  </Layout>
</template>

<script>
import { apiRequest } from '@/serves/http'
import { Dialog } from 'element-ui'
import { MARK_RESULT_TYPE } from '@/config'
import analytics from '@/utils/AnalyticsCenter'
import { mixinMixpanel } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
export default {
  mixins: [mixinMixpanel],
  data() {
    return {
      currentQuesIndex: 1,
      currentModule: '',
      questionNum: 0,
      // 保存题目的数组
      questionAnswerList: [],
      questionIfSave: false, // 是否预保存题目列表
      // activeName: "1", // 答题卡默认打开第一个
      status: true, // true 为点击下一题进入 ,false为选择题号进入
      groupAnsList: [], // 套题存作答记录数组
      partIcon: {
        listen: require('@/assets/images/listen-part.png'),
        read: require('@/assets/images/read-part.png'),
        write: require('@/assets/images/write-part.png'),
      },
      dialogVisible: false,
      answerSheetList: [],
      canSubmit: true,
      questionAllList: [],
      MARK_RESULT_TYPE: MARK_RESULT_TYPE,
    }
  },
  components: {
    [Dialog.name]: Dialog,
  },
  props: {
    // 倒计时的总时间
    time: {
      type: Number,
      default: 30 * 60 * 60 * 1000,
    },
    // 题目对象
    selectObj: {
      type: Object,
      default: () => {},
    },
    // 是否显示播放按钮
    showButtonPlay: {
      type: Boolean,
      default: true,
    },
    showButtonPause: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    // 答案
    answerObject: {
      type: Object,
      default: () => {},
    },
    // 作答记录对象
    answerNotesArray: {
      type: Array,
      default: () => [],
    },
    //是否显示倒计时
    isShowCountDown: {
      type: Boolean,
      default: true,
    },
    // 是否答题模式
    isExamMode: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('level', {
      levelTypeName: 'levelTypeName',
    }),
    ...mapState({
      // 等级信息
      levelActiveIndex: (state) => state.level.levelActiveIndex,
    }),
    disabledPrevButton() {
      let total = 1
      // // 如果第一道题就是组题的情况
      if (this.selectObj.questionList[0].questions) {
        total = this.selectObj.questionList[0].questions.length
      }
      if (this.isExamMode) {
        this.selectObj.questionList.forEach(() => {
          let firstQuestion = this.selectObj.questionList[0]
          if (firstQuestion.questions) {
            total = firstQuestion.bigIndex + firstQuestion.questions.length - 1
          } else {
            total = firstQuestion.count + 1
          }
        })
      }
      return this.currentQuesIndex <= total
    },
    disabledNextButton() {
      let total
      this.selectObj.questionList.forEach((eg) => {
        if (eg.questions) {
          total = eg.bigIndex - 1
        } else {
          total = eg.count
        }
      })
      return this.currentQuesIndex - 1 >= total
    },
    computedCurrentNum() {
      return this.questionAllList[this.currentQuesIndex - 1].index || ''
    },
    computedCurrentIndex() {
      return function (questionId) {
        let filterData = this.selectObj.questionList.filter((item) => {
          return !item.is_example
        })
        let index = filterData.findIndex((item) => {
          return item.index == questionId
        })
        return index + 1
      }
    },
    computedIsShowResult() {
      return !Object.values(MARK_RESULT_TYPE).includes(this.selectObj?.topic_type)
    },
    computedTebCurrentIndex() {
      return function (questionId) {
        let index = this.selectObj.questionList.findIndex((item) => {
          return item.index == questionId
        })
        return index + 1
      }
    },
    correctNum() {
      let num = this.questionAnswerList.filter((item) => {
        return item.judge == 1
      })
      return num.length
    },
    // 根据当前索引值获取当前题的对象
    getAuesObj() {
      const that = this
      let currentObj = {}
      that.questionNum = 0
      let i = 1
      that.selectObj.questionList.forEach((item, index) => {
        let ansObj = {
          questionId: item.index,
          questionIndex: index + 1,
          answer: '',
          judge: 0,
          scores: Object.values(MARK_RESULT_TYPE).includes(that.selectObj?.topic_type) ? null : 0,
          segmentCode: item.segment_code,
          partCode: item.part_code,
          ifGroup: item.ifGroup,
          num: item.num,
          nnum: item.nnum,
          question_type: that.selectObj?.topic_type,
        }
        // 预存所有题目,有值则不存
        if (!that.questionIfSave && !item.is_example) {
          that.questionAnswerList.push(ansObj)
        }
        that.questionNum++ // 总题数
        if (i == that.currentQuesIndex) {
          currentObj = item
          that.currentModule = this.selectObj.topic_title // 赋值title
        }
        i++
      })
      that.questionIfSave = true
      return currentObj
    },
  },
  watch: {
    // 监听选择了答案直接下一题
    answerObject: {
      handler(newVal) {
        console.log(newVal, this.questionAnswerList)
        //questionAnswerList不能为空,如果为空需要重新赋值
        if (!this.questionAnswerList.length) {
          this.questionIfSave = false
          this.getAuesObj()
        }
        // 如果作答过 不自动下一题
        // 如果未作答且套题最后一个也不自动下一题
        if (
          !this.questionAnswerList[this.computedCurrentIndex(newVal.questionId) - 1].answer &&
          !(
            this.questionAnswerList[this.computedCurrentIndex(newVal.questionId) - 1].ifGroup &&
            this.questionAnswerList[this.computedCurrentIndex(newVal.questionId) - 1].num === 1
          )
        ) {
          // 答完当题继续下一题
          if (
            this.computedTebCurrentIndex(newVal.questionId) < this.questionNum &&
            newVal.segmentCode != 'write' &&
            this.getAuesObj.topic_type != 'so'
          ) {
            this.currentQuesIndex = this.computedTebCurrentIndex(newVal.questionId) + 1
          }
        } else {
          this.currentQuesIndex = this.computedTebCurrentIndex(newVal.questionId)
          // 监听不到index变手动执行赋值
          //
          setTimeout(() => {
            this.selectQues()
          })
        }
        // 存题(未作答的也提交)
        Object.assign(
          this.questionAnswerList[this.computedCurrentIndex(newVal.questionId) - 1],
          newVal,
          {
            answer: newVal.answer.toString(),
          }
        )
        console.log('存进去的值', this.questionAnswerList)
      },
      deep: true,
    },

    // 监听序号变化就传题过去
    currentQuesIndex: {
      handler(val) {
        // 切题就暂停音频
        this.$emit('stop')
        console.log('停止===', val)
        if (this.status) {
          this.selectQues('', '', true)
        }
      },
      immediate: true,
    },
  },
  created() {
    let i = 0
    let k = 0
    console.log('this.selectObj', this.selectObj)
    // 给questionList拼装了count属性并且给yct类型的试题添加了index属性
    this.selectObj.questionList.forEach((ques) => {
      this.questionAllList.push(ques)
      if (!ques.index && !ques.is_example) {
        k++
        // 兼容yct没带index场景
        Object.assign(ques, { count: i }, { index: k })
        // 套题小题中的题干无index,手动拼接
        if (ques.questions) {
          ques.questions.forEach((q, z) => {
            q.index = this.selectObj.questionList[0].index + z
          })
        }
      } else {
        Object.assign(ques, { count: i })
      }
      i++
    })
    if (this.answerNotesArray.length) {
      this.questionAnswerList = this.answerNotesArray
      console.log('this.questionAnswerList=-----', this.questionAnswerList)
      this.questionIfSave = true
      if (this.$route.query.currentQuesIndex) {
        this.currentQuesIndex = this.$route.query.currentQuesIndex
      }
    }
    console.log('this.questionAllList====', this.questionAllList)
    // 选择题目
    this.selectQues()
    let mixpanelParams = {
      exam_type: this.$route.query.exam_type,
      section: this.$route.query.section,
      part: this.$route.query.part,
    }
    analytics.logEvent('hskweb_sampletry_view', mixpanelParams)
  },
  methods: {
    // 提交试卷且暂停倒计时
    submit() {
      this.dialogVisible = true
    },
    // 上一题
    onPrev() {
      if (this.disabledPrevButton) return
      // 如果是套题直接进入上一个大题
      if (this.questionAllList[this.currentQuesIndex - 1].ifGroup) {
        this.currentQuesIndex -= this.questionAllList[this.currentQuesIndex - 1].nnum
      } else {
        this.currentQuesIndex--
      }
    },
    // 下一题
    onNext() {
      if (this.disabledNextButton) return
      // 如果是套题直接进入下一个大题
      if (this.questionAllList[this.currentQuesIndex - 1].ifGroup) {
        this.currentQuesIndex += this.questionAllList[this.currentQuesIndex - 1].num
      } else {
        this.currentQuesIndex++
      }
    },
    // 播放点击事件
    playClickHandler() {
      this.$emit('play')
    },
    //暂停播放事件
    stopClickHandler() {
      this.$emit('pause')
    },
    // 选择题
    selectQues(quesObj, currentModule, status) {
      this.status = status
      let currQuesObj
      if (quesObj) {
        currQuesObj = quesObj
        this.currentQuesIndex =
          this.questionAllList.findIndex((item) => {
            return item.index == currQuesObj.index
          }) + 1
      } else {
        currQuesObj = this.getAuesObj
        console.log('this.getAuesObj=====', this.getAuesObj, this.currentQuesIndex)
      }
      currentModule ? (this.currentModule = currentModule) : ''
      // 把自己的答案拼进去,已便于做题回显
      // 1,套题  2,非套题
      let j = 0
      // 套题类型
      if (currQuesObj.questions) {
        // 判断当前套题前面有几个例题
        let exampleNum = this.questionAllList.filter((item) => {
          return item.bigIndex < currQuesObj.bigIndex && item.is_example
        }).length
        console.log('currQuesObj.questions', currQuesObj)
        for (let i = 0; i < currQuesObj.questions.length; i++) {
          if (currQuesObj.questions[i].is_example) continue
          this.groupAnsList[j] =
            this.questionAnswerList[currQuesObj.bigIndex - 1 + j - exampleNum].answer
          j++
        }
        console.log('套题存的数组', this.groupAnsList)
        Object.assign(currQuesObj, {
          answer: this.groupAnsList,
        })
      } else {
        // 非套题
        Object.assign(currQuesObj, {
          answer: this.questionAnswerList[this.currentQuesIndex - 1].answer,
        })
      }
      // this.getBigType()
      this.$emit('currentSelect', currQuesObj)
      console.log('回传的数据（用于记录作答记录）', currQuesObj)

      this.$nextTick(() => {
        this.status = true
      })
    },
    // 保存答案调用接口
    saveApiRequest(status) {
      let obj = {
        paperIdStr: this.$route.query.paperId,
        paperId: 1,
        questionAnswerList: this.questionAnswerList,
        countDown: -1,
        examinationType: 3,
      }
      apiRequest.post(ApiPath.hsk_save_result, obj, { loading: true }).then((res) => {
        this.canSubmit = true
        let jsonData = JSON.parse(localStorage.getItem('practiceJson'))
        jsonData.answerNotesArray = this.questionAnswerList
        localStorage.setItem('practiceJson', JSON.stringify(jsonData))
        status && this.submitResult()
      })
    },
    // 提交试卷
    submitResult() {
      let num = 0
      this.questionAnswerList.forEach((item) => {
        num += item.scores
      })
      let mixpanelParams = {
        people_id: this.peopleId,
        unlimited: this.unlimited,
        exam_type: this.$route.query.exam_type,
        section: this.$route.query.section,
        part: this.$route.query.part,
        mark: num,
      }
      utilV2.postData(
        ApiPath.hsk_submit_result,
        { paperId: this.$route.query.paperId, examinationType: 3 },
        (data) => {
          analytics.logEvent('hskweb_samplesubmit_click', {
            ...mixpanelParams,
            success_submitted: true,
          })
          this.$emit('submitAnswer')
          this.$router.replace({
            name: 'ExaminationUpgrade',
            params: {
              ...this.selectObj,
            },
            query: {
              ...this.$route.query,
              currentQuesIndex: 1,
              paperStatus: 1,
              report: true,
              ifRecord: true,
            },
          })
          console.log('提交成功', this.questionAnswerList)
          // 提交成功暂停音频播放
          this.$emit('pause')
          if (this.currentQuesIndex == 1) {
            this.selectQues('', '', true)
          } else {
            this.currentQuesIndex = 1
          }
        },
        (err) => {
          analytics.logEvent('hskweb_samplesubmit_click', {
            ...mixpanelParams,
            success_submitted: false,
          })
        }
      )
    },
    cancel() {
      this.dialogVisible = false
      this.canSubmit = true
    },
    async confirm() {
      if (!this.canSubmit) {
        return
      }
      this.canSubmit = false
      this.saveApiRequest(true)
      this.dialogVisible = false
    },
    // 跳转正式考试
    jumpTest() {
      let mixpanelParams = {
        exam_type: this.$route.query.exam_type,
        section: this.$route.query.section,
        part: this.$route.query.part,
      }
      analytics.logEvent('hskweb_sampletomock_click', mixpanelParams)
      // this.$router.push({
      //   path: `/${this.levelTypeName || 'hsk'}/index`,
      // })
      if (this.levelTypeName == 'hsk-3') {
        this.$router.push({
          path: `/new-hsk/tests`,
          query: {
            level: `${this.levelTypeName}${this.levelActiveIndex}`,
          },
        })
      } else {
        this.$router.push({
          path: `/${this.levelTypeName || 'hsk'}/tests`,
          query: {
            level: `${this.levelTypeName}${this.levelActiveIndex}`,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content-body {
  flex-direction: row;
  justify-content: center;
  .stem {
    width: 750px;
    min-height: 498px;
    height: auto;
    flex: initial;
    &--title {
      min-height: 74px;
      border-bottom: 1px solid #ebeff2;
      &_text {
        padding: 15px 28px;
        .proportion {
          display: flex;
          justify-content: space-between;
          span {
            display: inline-block;
            font-size: 12px;
            // font-family: PingFangSC-Regular, Inter;
            font-weight: 400;
            color: rgba(134, 141, 153, 1);
            line-height: 12px;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .tools {
    position: relative;
    width: 220px;
    min-height: 498px;
    margin-right: 30px;
    flex: initial;
    .count_down {
      margin-top: 34px;
    }
    .time-remaining {
      font-size: 12px;
      font-weight: 400;
      color: rgba(134, 141, 153, 1);
      line-height: 12px;
      margin-top: 10px;
      text-align: center;
    }
    .btn-submit {
      width: 182px;
      height: 28px;
      border-radius: 14px;
    }
    ::v-deep.toolbar {
      height: 78px;
      border-bottom: 1px solid #e6eaef;
    }
    .toolbar-submit {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      border: none;
    }
    .subject_list {
      padding: 0px 18px;
      .collapse-list {
        margin-top: 30px;
        border: 0;
        ::v-deep.el-collapse-item {
          margin-bottom: 20px;
          &__header {
            border-radius: 14px;
            border: 1px solid rgba(208, 213, 221, 1);
            width: 180px;
            height: 28px;
          }
          &__wrap {
            border: 0;
          }
          &__content {
            padding-bottom: 0;
          }
        }
        .type {
          margin-left: 7px;
          font-size: 12px;
          font-weight: 500;
          color: rgba(57, 61, 70, 1);
          line-height: 12px;
        }
        img {
          margin-left: 17px;
        }
      }
      &-flex {
        width: 100%;
        display: flex;
        position: relative;
        justify-content: center;
      }
      &-line {
        width: 100%;
        height: 1px;
        background-color: #f6f8fc;
        position: absolute;
        left: 0px;
        top: 16px;
      }
      &-item {
        margin: 13px 0 0 4px;
        span {
          display: inline-block;
          width: 24px;
          height: 24px;
          border: 1px solid #ebeff2;
          border-radius: 12px;
          margin-right: 10px;
          margin-bottom: 10px;
          text-align: center;
          font-size: 10px;
          color: rgba(57, 61, 70, 1);
          line-height: 22px;
          cursor: pointer;
        }
        .title {
          margin-bottom: 15px;
          margin-top: 10px;
          font-size: 10px;
          font-weight: 400;
          color: rgba(121, 124, 127, 1);
          line-height: 12px;
          display: inline-block;
          background-color: #fff;
          z-index: 2;
          padding: 0px 10px;
        }
        .active {
          background-color: #faae56;
          color: #fff;
        }
        .finished {
          border-color: #faae56;
        }
        .right {
          border-color: #09cba0;
          color: #09cba0;
          background-color: #fff;
        }
        .error {
          border-color: #fc5a5a;
          color: #fc5a5a;
          background-color: #fff;
        }
      }
    }
    .hsk-tips {
      margin-top: 20px;
      text-align: center;
      margin-top: 20px;
      font-size: 14px;
      font-weight: bold;
      padding: 0 27px;
      line-height: 17px;
    }
  }
}
.page-tools {
  display: flex;
  width: 750px;
  justify-content: space-around;
  margin-top: 21px;
  ::v-deep.elst-button__prev,
  ::v-deep.elst-button__next {
    img {
      width: 63px;
      height: 63px;
    }
  }
}
::v-deep .el-dialog__footer {
  padding: 0;
}
::v-deep .el-dialog__header {
  padding: 0;
}
::v-deep .el-dialog__body {
  text-align: center;
  font-size: 17px;
}
.dialog-footer {
  display: flex;
  align-items: center;
  border-top: 1px solid #f2f3f5;
  span {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 59px;
    cursor: pointer;
    &:first-child {
      border-right: 1px solid #f2f3f5;
    }
  }
}
.result {
  &-num {
    font-size: 16px;
    color: #3e4651;
    font-weight: 500;
    text-align: center;
    padding: 0 8px;
  }
  &-correct {
    color: #faae56;
  }
}
</style>
